import { useEffect, useState } from 'react';
import { getDataConnector, getDataConnectorGlobal } from '../../requests/request';
import { useAppSelector } from "../../../../../../redux/hooks";
import Pruebachart from './widgetconnectores';

export default function CloudconnectorVert(props: any) {
    const Id = useAppSelector(state => state.SuscriptionSlice.id);
    const tenant = useAppSelector(state => state.TenantSlice.id);
    const Cloud = useAppSelector(state => state.CloudSlice.Type);
    const nameregion = useAppSelector(state => state.RegionSlice.name);
    const FlagReg = useAppSelector(state => state.FlagSlice.value);

    const [DataAvailable, setDataAvailable] = useState({
        Available_DTR_CPR: 0,
        DateUpdate_DTR_CPR: '',
        exceeded_DTR_CPR: 0,
        Total_DTR_CPR: 1,
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (Id !== 0 && Id !== -1 && Cloud !== 'CloudGlobal') {
                    const available = tenant === 0
                        ? await getDataConnector(Id, props.source, Cloud, nameregion)
                        : await getDataConnectorGlobal(Id, tenant, props.source, Cloud, nameregion);

                    setDataAvailable(available.data);
                } else if (Id !== 0 && Id !== -1 && Cloud === 'CloudGlobal') {
                    const available = tenant === 0
                        ? await getDataConnector(Id, props.source)
                        : await getDataConnectorGlobal(Id, tenant, props.source);

                    setDataAvailable(available.data);
                }
            } catch (error) {
                console.error('Error al obtener las cuentas:', error);
            }
        };

        fetchData();
    }, [Id, nameregion, props.id]);

    const chartColor = DataAvailable.exceeded_DTR_CPR !== 0 ? 'danger' : 'marino';

    return (
        <Pruebachart
            exedido={DataAvailable.exceeded_DTR_CPR}
            name='Cloud Connector'
            total={DataAvailable.Total_DTR_CPR}
            disponible={DataAvailable.Available_DTR_CPR}
            className='card-xl-stretch'
            chartColor={chartColor}
            chartHeight={300}
        />
    );
}
